var _path, _path2, _mask, _path3, _path4, _path5, _path6, _path7, _mask2, _path8, _path9, _rect, _rect2, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGas2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 335 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.621 426.805C313.345 426.779 331.746 408.369 331.755 385.662V125.805C331.746 103.081 313.345 84.68 290.621 84.645H249M44.1337 426.805C21.41 426.779 3.00875 408.369 3 385.662V125.805C3.00875 103.081 21.41 84.68 44.1337 84.645H85.755",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.621 426.805C313.345 426.779 331.746 408.369 331.755 385.662V125.805C331.746 103.081 313.345 84.68 290.621 84.645H249M44.1337 426.805C21.41 426.779 3.00875 408.369 3 385.662V125.805C3.00875 103.081 21.41 84.68 44.1337 84.645H85.755",
    stroke: "url(#paint0_linear)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.544 433.482H127.23C112.189 433.473 100.009 421.284 100 406.243V194.248C100.009 179.206 112.189 167.018 127.23 167H208.544C223.594 167.018 235.765 179.206 235.8 194.248V406.243C235.765 421.284 223.594 433.473 208.544 433.482Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M208.544 433.482H127.23C112.189 433.473 100.009 421.284 100 406.243V194.248C100.009 179.206 112.189 167.018 127.23 167H208.544C223.594 167.018 235.765 179.206 235.8 194.248V406.243C235.765 421.284 223.594 433.473 208.544 433.482Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.23 433.482L127.227 438.482H127.23V433.482ZM208.544 433.482L208.544 438.482L208.547 438.482L208.544 433.482ZM235.8 406.243L240.8 406.255V406.243H235.8ZM235.8 194.248L240.8 194.248L240.8 194.236L235.8 194.248ZM208.544 167L208.55 162H208.544V167ZM127.23 167L127.23 162L127.224 162L127.23 167ZM100 194.248L95 194.245V194.248H100ZM100 406.243L95 406.243L95 406.246L100 406.243ZM127.23 438.482H208.544V428.482H127.23V438.482ZM208.547 438.482C226.361 438.471 240.759 424.044 240.8 406.255L230.8 406.231C230.771 418.525 220.827 428.475 208.541 428.482L208.547 438.482ZM240.8 406.243V194.248H230.8V406.243H240.8ZM240.8 194.236C240.759 176.447 226.361 162.021 208.55 162L208.538 172C220.827 172.014 230.771 181.966 230.8 194.259L240.8 194.236ZM208.544 162H127.23V172H208.544V162ZM127.224 162C109.425 162.021 95.0104 176.446 95 194.245L105 194.25C105.007 181.967 114.953 172.014 127.236 172L127.224 162ZM95 194.248V406.243H105V194.248H95ZM95 406.246C95.0104 424.044 109.425 438.471 127.227 438.482L127.233 428.482C114.953 428.475 105.007 418.524 105 406.24L95 406.246Z",
    fill: "white",
    mask: "url(#path-2-inside-1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.23 433.482L127.227 438.482H127.23V433.482ZM208.544 433.482L208.544 438.482L208.547 438.482L208.544 433.482ZM235.8 406.243L240.8 406.255V406.243H235.8ZM235.8 194.248L240.8 194.248L240.8 194.236L235.8 194.248ZM208.544 167L208.55 162H208.544V167ZM127.23 167L127.23 162L127.224 162L127.23 167ZM100 194.248L95 194.245V194.248H100ZM100 406.243L95 406.243L95 406.246L100 406.243ZM127.23 438.482H208.544V428.482H127.23V438.482ZM208.547 438.482C226.361 438.471 240.759 424.044 240.8 406.255L230.8 406.231C230.771 418.525 220.827 428.475 208.541 428.482L208.547 438.482ZM240.8 406.243V194.248H230.8V406.243H240.8ZM240.8 194.236C240.759 176.447 226.361 162.021 208.55 162L208.538 172C220.827 172.014 230.771 181.966 230.8 194.259L240.8 194.236ZM208.544 162H127.23V172H208.544V162ZM127.224 162C109.425 162.021 95.0104 176.446 95 194.245L105 194.25C105.007 181.967 114.953 172.014 127.236 172L127.224 162ZM95 194.248V406.243H105V194.248H95ZM95 406.246C95.0104 424.044 109.425 438.471 127.227 438.482L127.233 428.482C114.953 428.475 105.007 418.524 105 406.24L95 406.246Z",
    fill: "url(#paint1_linear)",
    mask: "url(#path-2-inside-1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "flame",
    d: "M157.356 304.031C154.005 318.097 140.425 327.704 157.003 344C129.314 331.478 133.723 311.236 143.566 294.596C153.409 277.957 159.723 268.434 161.413 256C177.991 271.439 188.189 281.559 196.157 298.027C204.125 314.495 200.566 339.197 177.286 344C196.157 328.047 191.748 304.031 171.466 286.877C172.812 300.289 170.587 306.777 164.411 317.583C163.174 311.184 161.432 308.36 157.356 304.031Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "flame2",
    d: "M157.356 304.031C154.005 318.097 140.425 327.704 157.003 344C129.314 331.478 133.723 311.236 143.566 294.596C153.409 277.957 159.723 268.434 161.413 256C177.991 271.439 188.189 281.559 196.157 298.027C204.125 314.495 200.566 339.197 177.286 344C196.157 328.047 191.748 304.031 171.466 286.877C172.812 300.289 170.587 306.777 164.411 317.583C163.174 311.184 161.432 308.36 157.356 304.031Z",
    stroke: "url(#paint2_linear)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127 91C127 82.7157 133.716 76 142 76H192C200.284 76 207 82.7157 207 91C207 99.2843 200.284 106 192 106H187V131H242C258.569 131 272 144.431 272 161V444C272 460.569 258.569 474 242 474H92C75.4315 474 62 460.569 62 444V161C62 144.431 75.4315 131 92 131H147V106H142C133.716 106 127 99.2843 127 91Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187 106V101C184.239 101 182 103.239 182 106H187ZM187 131H182C182 133.761 184.239 136 187 136V131ZM147 131V136C149.761 136 152 133.761 152 131H147ZM147 106H152C152 103.239 149.761 101 147 101V106ZM142 71C130.954 71 122 79.9543 122 91H132C132 85.4772 136.477 81 142 81V71ZM192 71H142V81H192V71ZM212 91C212 79.9543 203.046 71 192 71V81C197.523 81 202 85.4772 202 91H212ZM192 111C203.046 111 212 102.046 212 91H202C202 96.5228 197.523 101 192 101V111ZM187 111H192V101H187V111ZM182 106V131H192V106H182ZM242 126H187V136H242V126ZM277 161C277 141.67 261.33 126 242 126V136C255.807 136 267 147.193 267 161H277ZM277 444V161H267V444H277ZM242 479C261.33 479 277 463.33 277 444H267C267 457.807 255.807 469 242 469V479ZM92 479H242V469H92V479ZM57 444C57 463.33 72.67 479 92 479V469C78.1929 469 67 457.807 67 444H57ZM57 161V444H67V161H57ZM92 126C72.67 126 57 141.67 57 161H67C67 147.193 78.1929 136 92 136V126ZM147 126H92V136H147V126ZM152 131V106H142V131H152ZM142 111H147V101H142V111ZM122 91C122 102.046 130.954 111 142 111V101C136.477 101 132 96.5228 132 91H122Z",
    fill: "white",
    mask: "url(#path-5-inside-2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187 106V101C184.239 101 182 103.239 182 106H187ZM187 131H182C182 133.761 184.239 136 187 136V131ZM147 131V136C149.761 136 152 133.761 152 131H147ZM147 106H152C152 103.239 149.761 101 147 101V106ZM142 71C130.954 71 122 79.9543 122 91H132C132 85.4772 136.477 81 142 81V71ZM192 71H142V81H192V71ZM212 91C212 79.9543 203.046 71 192 71V81C197.523 81 202 85.4772 202 91H212ZM192 111C203.046 111 212 102.046 212 91H202C202 96.5228 197.523 101 192 101V111ZM187 111H192V101H187V111ZM182 106V131H192V106H182ZM242 126H187V136H242V126ZM277 161C277 141.67 261.33 126 242 126V136C255.807 136 267 147.193 267 161H277ZM277 444V161H267V444H277ZM242 479C261.33 479 277 463.33 277 444H267C267 457.807 255.807 469 242 469V479ZM92 479H242V469H92V479ZM57 444C57 463.33 72.67 479 92 479V469C78.1929 469 67 457.807 67 444H57ZM57 161V444H67V161H57ZM92 126C72.67 126 57 141.67 57 161H67C67 147.193 78.1929 136 92 136V126ZM147 126H92V136H147V126ZM152 131V106H142V131H152ZM142 111H147V101H142V111ZM122 91C122 102.046 130.954 111 142 111V101C136.477 101 132 96.5228 132 91H122Z",
    fill: "url(#paint3_linear)",
    mask: "url(#path-5-inside-2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 2.5,
    width: 154,
    height: 26,
    rx: 13,
    stroke: "white",
    strokeWidth: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 2.5,
    width: 154,
    height: 26,
    rx: 13,
    stroke: "url(#paint4_linear)",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105 28L105 133",
    stroke: "white",
    strokeWidth: 5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105 28L105 133",
    stroke: "url(#paint5_linear)",
    strokeWidth: 5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M229 28L229 133",
    stroke: "white",
    strokeWidth: 5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M229 28L229 133",
    stroke: "url(#paint6_linear)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 167.378,
    y1: 84.645,
    x2: 167.378,
    y2: 426.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 167.9,
    y1: 167,
    x2: 167.9,
    y2: 433.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 168,
    y1: 256,
    x2: 168,
    y2: 344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 167,
    y1: 76,
    x2: 167,
    y2: 474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 167.5,
    y1: 0,
    x2: 167.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 105.5,
    y1: 28,
    x2: 105.5,
    y2: 133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 229.5,
    y1: 28,
    x2: 229.5,
    y2: 133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas2);
export default __webpack_public_path__ + "static/media/gas2.284c0b39550e7a3e6e4fb3b8c9510ff9.svg";
export { ForwardRef as ReactComponent };